var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHealthCare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_health_Care",
    "data-name": "ic_health Care",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_hand",
    d: "M86.618,17.576A13.761,13.761,0,0,0,68.647,19.97L59.84,30.015a11.009,11.009,0,0,0-10.293-7.238h-2.56a6.991,6.991,0,0,1-3.881-1.183,25.815,25.815,0,0,0-32.531,3.22l-9.77,9.77a2.763,2.763,0,1,0,3.908,3.908l9.77-9.77A20.229,20.229,0,0,1,40.051,26.19a12.44,12.44,0,0,0,6.936,2.092h2.56a5.5,5.5,0,0,1,5.5,5.5H35.786a2.752,2.752,0,0,0,0,5.5H57.8a2.752,2.752,0,0,0,2.037-.963h0L72.747,23.575A8.257,8.257,0,0,1,81,21.043L61.656,47a8.257,8.257,0,0,1-6.605,3.3H32.1a13.761,13.761,0,0,0-9.743,4.018L20.071,56.6a2.763,2.763,0,1,0,3.908,3.908l2.284-2.284A8.257,8.257,0,0,1,32.1,55.8H55.051A13.761,13.761,0,0,0,66.06,50.3L87.527,21.676a3.027,3.027,0,0,0,.413-2.2A3.193,3.193,0,0,0,86.618,17.576Z",
    transform: "translate(0 26.676)",
    fill: "#354e57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_hos"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3964",
    "data-name": "\\uD328\\uC2A4 3964",
    d: "M37.77,38.531H26.761a2.752,2.752,0,0,1-2.752-2.752V27.522H15.752A2.752,2.752,0,0,1,13,24.77V13.761a2.752,2.752,0,0,1,2.752-2.752h8.257V2.752A2.752,2.752,0,0,1,26.761,0H37.77a2.752,2.752,0,0,1,2.752,2.752v8.257h8.257a2.752,2.752,0,0,1,2.752,2.752V24.77a2.752,2.752,0,0,1-2.752,2.752H40.522v8.257A2.752,2.752,0,0,1,37.77,38.531Zm-8.257-5.5h5.5V24.77a2.752,2.752,0,0,1,2.752-2.752h8.257v-5.5H37.77a2.752,2.752,0,0,1-2.752-2.752V5.5h-5.5v8.257a2.752,2.752,0,0,1-2.752,2.752H18.5v5.5h8.257a2.752,2.752,0,0,1,2.752,2.752Z",
    transform: "translate(22.786)",
    fill: "#5289c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3965",
    "data-name": "\\uD328\\uC2A4 3965",
    d: "M4377.575,1124.413h11.5l-1.5-9.738h9.5l2,7.708,10.35,3.6-1,7.348-2,1.053-6.35,2.03-3,11.151h-9.5v-11.151s-11.5-1.336-11.5-2.03S4377.575,1124.413,4377.575,1124.413Z",
    transform: "translate(-4338.004 -1109.887)",
    fill: "#5289c9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHealthCare);
export default __webpack_public_path__ + "static/media/ic_health Care.7e31df04297cf0a1f08776143ec6378e.svg";
export { ForwardRef as ReactComponent };